import { kodiakTlaSkusEquivalent } from "@integrator-src/mrp/kodiak-pcba-prefix-planned";

export type ConfigurationQueueTlaFilterKey =
  | "fi_3c_n_tla_a"
  | "fi_3c_n_tla_c"
  | "fi_3c_b_tla_a"
  | "fi_3c_b_tla_c"
  | "fi_3c_q_tla_a"
  | "fi_3c_q_tla_c"
  | "fi_5a_n_tla"
  | "fi_5a_w_tla"
  | "baba_fi_5a_w_tla"
  | "abb_fi_3c_b_tla_a"
  | "abb_fi_3c_b_tla_c"
  | "abb_fi_5a_n_tla"
  | "abb_fi_5a_w_tla"
  | "other";

export const CONFIGURATION_QUEUE_TLA_FILTER_OPTIONS: Array<{
  key: ConfigurationQueueTlaFilterKey;
  label: string;
  matchTlaSku: string | null;
}> = [
  { key: "fi_3c_n_tla_a", label: "FI-3C-N-TLA-A", matchTlaSku: "FI-3C-N-TLA-A" },
  { key: "fi_3c_n_tla_c", label: "FI-3C-N-TLA-C", matchTlaSku: "FI-3C-N-TLA-C" },
  { key: "fi_3c_b_tla_a", label: "FI-3C-B-TLA-A", matchTlaSku: "FI-3C-B-TLA-A" },
  { key: "fi_3c_b_tla_c", label: "FI-3C-B-TLA-C", matchTlaSku: "FI-3C-B-TLA-C" },
  { key: "fi_3c_q_tla_a", label: "FI-3C-Q-TLA-A", matchTlaSku: "FI-3C-Q-TLA-A" },
  { key: "fi_3c_q_tla_c", label: "FI-3C-Q-TLA-C", matchTlaSku: "FI-3C-Q-TLA-C" },
  { key: "fi_5a_n_tla", label: "FI-5A-N-TLA", matchTlaSku: "FI-5A-N-TLA" },
  { key: "fi_5a_w_tla", label: "FI-5A-W-TLA", matchTlaSku: "FI-5A-W-TLA" },
  { key: "baba_fi_5a_w_tla", label: "BABA-FI-5A-W-TLA", matchTlaSku: "BABA-FI-5A-W-TLA" },
  { key: "abb_fi_3c_b_tla_a", label: "ABB-FI-3C-B-TLA-A", matchTlaSku: "ABB-FI-3C-B-TLA-A" },
  { key: "abb_fi_3c_b_tla_c", label: "ABB-FI-3C-B-TLA-C", matchTlaSku: "ABB-FI-3C-B-TLA-C" },
  { key: "abb_fi_5a_n_tla", label: "ABB-FI-5A-N-TLA", matchTlaSku: "ABB-FI-5A-N-TLA" },
  { key: "abb_fi_5a_w_tla", label: "ABB-FI-5A-W-TLA", matchTlaSku: "ABB-FI-5A-W-TLA" },
  { key: "other", label: "Other", matchTlaSku: null },
];

/** Strip Kodiak ALT alias prefix before normal TLA filter comparison. BABA/ABB stay distinct. */
export function normalizeConfigurationQueueTlaForFilter(tlaSku: string): string {
  return tlaSku.trim().replace(/^ALT-/i, "").toUpperCase();
}

function isBabaTlaSku(tlaSku: string): boolean {
  return normalizeConfigurationQueueTlaForFilter(tlaSku).startsWith("BABA-");
}

function isAbbTlaSku(tlaSku: string): boolean {
  return normalizeConfigurationQueueTlaForFilter(tlaSku).startsWith("ABB-");
}

export function configurationQueueTlaSkusMatchFilter(
  requiredTlaSku: string,
  filterMatchTlaSku: string,
): boolean {
  const normalizedRequired = normalizeConfigurationQueueTlaForFilter(requiredTlaSku);
  const normalizedFilter = normalizeConfigurationQueueTlaForFilter(filterMatchTlaSku);

  if (isBabaTlaSku(normalizedFilter) || isAbbTlaSku(normalizedFilter)) {
    return normalizedRequired === normalizedFilter;
  }

  if (isBabaTlaSku(normalizedRequired) || isAbbTlaSku(normalizedRequired)) {
    return false;
  }

  return kodiakTlaSkusEquivalent(normalizedRequired, normalizedFilter);
}

export function configurationQueueTlaFilterKeyForRequiredTla(
  requiredTlaSku: string | null | undefined,
): ConfigurationQueueTlaFilterKey {
  const trimmed = requiredTlaSku?.trim() ?? "";
  if (trimmed === "") {
    return "other";
  }
  for (const option of CONFIGURATION_QUEUE_TLA_FILTER_OPTIONS) {
    if (option.key === "other" || option.matchTlaSku == null) {
      continue;
    }
    if (configurationQueueTlaSkusMatchFilter(trimmed, option.matchTlaSku)) {
      return option.key;
    }
  }
  return "other";
}

export function configurationQueueItemMatchesTlaFilters(
  requiredTlaSku: string | null | undefined,
  selected: ReadonlySet<ConfigurationQueueTlaFilterKey>,
): boolean {
  if (selected.size === 0) {
    return true;
  }
  return selected.has(configurationQueueTlaFilterKeyForRequiredTla(requiredTlaSku));
}
